import { eHierarchyLevel } from "../enums";
import { ClinicalLibraryReadDto } from "./interface";

/**
 * Type guard that asserts whether a value conforms to the ClinicalLibraryReadDto shape.
 *
 * @param obj - The object to check
 * @returns boolean
 */
export const isClinicalLibraryReadDto = (obj: unknown): obj is ClinicalLibraryReadDto => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;
  // Check properties exist
  const chkObj = obj as ClinicalLibraryReadDto;
  if (typeof chkObj.id !== "number") return false;
  if (typeof chkObj.hierarchyId !== "string") return false;
  if (!Object.values(eHierarchyLevel).includes(chkObj.hierarchyLevel)) return false;
  if (typeof chkObj.corporateId !== "string") return false;
  if (typeof chkObj.taId !== "undefined" && typeof chkObj.taId !== "string") return false;
  if (typeof chkObj.projectId !== "undefined" && typeof chkObj.projectId !== "string") return false;
  if (typeof chkObj.studyId !== "undefined" && typeof chkObj.studyId !== "string") return false;
  if (typeof chkObj.version !== "number") return false;
  // Check arrays (basic check only)
  if (!Array.isArray(chkObj.clinicalDatasets)) return false;
  if (!Array.isArray(chkObj.clinicalCodeLists)) return false;
  if (!Array.isArray(chkObj.clinicalValueLists)) return false;
  if (!Array.isArray(chkObj.clinicalComments)) return false;
  if (!Array.isArray(chkObj.clinicalMethods)) return false;
  if (!Array.isArray(chkObj.clinicalWhereClauses)) return false;

  // Everything is good
  return true;
};
